import "./LandingPage.css"
import LandingNavBar from "../../Components/LandingPageComponents/Navbar/LandingNavBar";
import ContactSection from "../../Components/LandingPageComponents/ContactSection";
import LandingFooter from "../../Components/LandingPageComponents/Footer/LandingFooter";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import LandingModalContainer from "../../Modals/LandingModals/LandingModalContainer";
import { useGeneralContext } from "../../Contexts/GeneralContext/GeneralProvider";
import { GetRedirectURL } from "../../Helpers/TranslateHelpers";

function LandingPage() {

	const { authStatus, user } = useGeneralContext()

	const [currentModal, setCurrentModal] = useState<'WhatIs' | 'AboutUs' | 'Home'>('Home')

	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	useEffect(() => {
		handleScrollToTop();
	}, [currentModal]);

	// Signed-in users mostly land here by pressing back from the app, so send them home.
	if (authStatus === 'authenticated' && user) {
		return <Navigate to={GetRedirectURL(user.admin, user.school)} replace />
	}

	return (
		<div className="landing-page">
			<LandingNavBar
				setCurrentModal={setCurrentModal}
			/>
			<LandingModalContainer
				currentModal={currentModal}
				setCurrentModal={setCurrentModal}
			/>
			<ContactSection />
			<LandingFooter />
		</div>
	)
}

export default LandingPage;